export var TriggerRuleType;
(function (TriggerRuleType) {
    // 阀值
    TriggerRuleType[TriggerRuleType["Threshold"] = 0] = "Threshold";
    // 偏差
    TriggerRuleType[TriggerRuleType["Deviance"] = 1] = "Deviance";
    // 变化率
    TriggerRuleType[TriggerRuleType["ChangeRate"] = 2] = "ChangeRate";
    // 值变化
    TriggerRuleType[TriggerRuleType["Change"] = 3] = "Change";
})(TriggerRuleType || (TriggerRuleType = {}));
